import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DzButtonModule } from '@blk/daisy/elements/buttons';
import { SharedModule } from '@ddt-web/common';
import { DomService } from '@ddt-web/dom';
import { GenericDirectivesModule, LocalStorageKey } from '@ddt-web/generic-utils';
import { DebugQueryParamKey } from '@ddt-web/url';

import { WealthWebDebugBannerComponent } from './wealth-web-debug-banner.component';

@NgModule({
	declarations: [WealthWebDebugBannerComponent],
	imports: [
		CommonModule,
		SharedModule,
		DzButtonModule,
		GenericDirectivesModule
	],
	exports: [WealthWebDebugBannerComponent]
})
export class WealthWebDebugModule {
	constructor(private domService: DomService) {
		const parsedUrl = new URL(window.location.href);

		if (parsedUrl.searchParams.get(DebugQueryParamKey.MOCK_WEALTH_WEB) || localStorage.getItem(LocalStorageKey.MockWealthWeb)) {
			this.domService.prependComponentToBody(WealthWebDebugBannerComponent);
		}
	}
}
